import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
function Menu(props) {
   const ancho = props.selectProps.menuWidth ? {width: props.selectProps.menuWidth} : undefined;
   return (
      <Paper square style={ancho} className={props.selectProps.classes.paper} {...props.innerProps}>
         {props.children}
      </Paper>
   );
}

Menu.propTypes = {
   /**
    * The children to be rendered.
    */
   children: PropTypes.element.isRequired,
   /**
    * Props to be passed to the menu wrapper.
    */

   innerProps: PropTypes.object.isRequired,
   selectProps: PropTypes.object.isRequired
};
export default Menu;
